export default function Credit() {
  return (
    <div className="center_container">
      <ul>
        <li><span>文字记者：</span>夏念梓、张泰格、Mengyu、mulan、无言</li>
        <li><span>评论作者：</span>钟山</li>
        <li><span>文字编辑：</span>米米、Rosa Ng、John Tsang、Larry Fish</li>
        <li><span>数据编辑：</span>Paul Wang</li>
        <li><span>视频摄制：</span>X、Yusef Evans</li>
        <li><span>视频编辑：</span>Danni Gao、Yijo S.</li>
        <li><span>视频执行制片：</span>Vivian Lee</li>
        <li><span>插画：</span>missquai</li>
        <li><span>网页设计/制作：</span>Vic Kim</li>
        <li><span>内文网页设计/制作：</span>Regina Li</li>
        <li><span>设计指导：</span>Chris Wong</li>
        <li><span>策划：</span>米米</li>
        <li><span>总编：</span>Alex Zhang</li>
        <li><span>出品人：</span>Min Mitchell</li>
      </ul>
    </div>
  )
}
